/* eslint-disable */
import store from '@/store';
const ls = require('local-storage')

const obj = {
  listenUserState() {
    return new Promise((resolve) => {
      const token = ls.get('userToken');
      if (token) {
        store.dispatch('auth/loginWithUserToken', token);
        resolve(token);
      } else {
        store.dispatch('auth/logout');
        resolve(null);
      }
    });
  },
};

export default obj;
